export const AUTH_TOKEN =
  process.env.REACT_APP_AUTH_TOKEN || "graphcool-auth-token";
export const SERVER_WS_URL =
  process.env.REACT_APP_SERVER_WS_URL || "ws://127.0.0.1:8000/xhr/";
export const SERVER_HTTP_URL =
  process.env.REACT_APP_SERVER_HTTP_URL || "http://127.0.0.1:8000";

export const FIREBASE_API_KEY =
  process.env.REACT_APP_FIREBASE_API_KEY ||
  "AIzaSyDJypUNOaUr0-z8rqcr9F185SXZ6rVkhnE";
export const FIREBASE_PROJECT_ID =
  process.env.REACT_APP_FIREBASE_PROJECT_ID || "mendayz";
export const FIREBASE_APP_ID =
  process.env.REACT_APP_FIREBASE_APP_ID ||
  "1:937250424205:web:cf9fff69a0602bff5a69c4";
export const FIREBASE_MESSAGING_SENDER_ID =
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "937250424205";
export const FIREBASE_PUBLIC_VAPID_KEY =
  process.env.REACT_APP_FIREBASE_PUBLIC_VAPID_KEY ||
  "BKqNZX8-AxLTpGaB3NNh_9Blgbx0rKOe5_HVT8TrBb4wglyOLSioJAECONbtGZsKoJaOZIkyRMufu-csrEo2Rps";

export const IS_STAGING = process.env.REACT_APP_IS_STAGING || false;



// WEBPACK FOOTER //
// ./src/constants.js